import {
  AnalyticsEvent,
  EventParameters,
} from "@adsk/acc-issues-core/utils/analytics/analyticsTypes";

export class IssueEditBulkEditDeleteSuccessEvent implements AnalyticsEvent {
  name = "issue.edit.bulk_edit.delete.success";
  parameters: EventParameters;

  constructor(params: { selectedCount: number }) {
    this.parameters = {
      ...params,
    };
  }
}
